import { GraphType } from "../../../../../gd-modules/dashboard/widgets/constants/types";
import GroupBy from "../../../../../gd/manager/group-by/group-by-model";
import { DateIntervalType } from "../../../../../gd/utils/datetime/interval";
import { TimelineChartDataSource } from "./@conts";
import { ReportDate } from '../../../../../fields3/system/agile/report-date/model/model';


export default class ReportTasksTimeChart_Settings {

    public projectIds       : ID[] | null
    public graphType        : GraphType

    // public groupBy          : ID    // field we group by
    // public counterType      : CounterType

    public dimensionGroupBy : GroupBy    // field we group by
    public dataSource       : TimelineChartDataSource
    // public dimensionFieldId : ID    // field we group by
    // public interval         : DateIntervalType // day week etc
    public metricFieldId    : ID    // field we calculate based on (“the number you’re aggregating”)

    public includeSubtasks  : boolean
    public showClosedTasks  : boolean
    public snapshotDateRange : ReportDate;
    public snapshotMetricType : string;

    public reportTitle      : string = ''


    constructor(data: any) {
        this.projectIds         = _.get(data, "projectIds", [])
        this.graphType          = _.get(data, "graphType", GraphType.LINE)
        this.dataSource         = _.get(data, "dataSource", TimelineChartDataSource.REAL_TIME)

        const groupByConfig     = _.get(data, "dimensionGroupBy", {
            fieldId               : gd.fields.task.momentCreated.fieldId,
            params                : {
                interval            : DateIntervalType.DAILY
            }
            // sortDirection       : SortDirection.ASC
        })
        this.dimensionGroupBy   = new GroupBy(groupByConfig)

        // this.dimensionFieldId   = _.get(data, "dimensionFieldId", gd.fields.task.momentCreated.fieldId)
        // this.interval           = _.get(data, "interval", DateIntervalType.DAILY)
        this.metricFieldId      = _.get(data, "metricFieldId", gd.fields.task.taskCounter.fieldId)

        this.includeSubtasks    = _.get(data, "includeSubtasks", false)
        this.showClosedTasks    = _.get(data, "showClosedTasks", false)

        // Add snapshotDateRange
        this.snapshotDateRange = new ReportDate(_.get(data, "snapshotDateRange", { lastDays: 30 }))
        // Add snapshotMetricType
        this.snapshotMetricType = _.get(data, "snapshotMetricType", "total_tasks")
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectIds          : this.projectIds,
            graphType           : this.graphType,
            dataSource          : this.dataSource,

            dimensionGroupBy    : this.dimensionGroupBy.toJSON(),
            // dimensionFieldId    : this.dimensionFieldId,
            // interval            : this.interval,
            metricFieldId       : this.metricFieldId,

            includeSubtasks     : this.includeSubtasks,
            showClosedTasks     : this.showClosedTasks,
            snapshotDateRange   : this.snapshotDateRange.toJSON(),
            snapshotMetricType  : this.snapshotMetricType,
        }

        return result
    }
}
